import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { ClientForm } from '../Forms/Client.form';
export const ClientActions = ({
  fn = {
    handler: () => ({}),
    handlerSelected: () => ({}),
    selected: {},
  },
  modal = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
  onZipCode = () => ({}),
  onIsValid = () => ({}),
  onAddress = () => ({}),
}) => {
  return (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modal.handler(false);
        modal.form.resetFields();
      }}
      onOk={() => modal.form.submit()}
      okText={fn.selected?.id ? 'Actualizar' : 'Crear'}
      okButtonProps={{
        loading: modal.loading,
      }}
      title={fn.selected?.id ? 'Actualizar cliente' : 'Crear cliente'}
      visible={modal.visible}
      width={1000}
    >
      <ClientForm
        formRef={modal.form}
        onSubmit={modal.submit}
        onZipCode={onZipCode}
        onIsValid={onIsValid}
        onAddress={onAddress}
      />
    </Modal>
  );
};

ClientActions.propTypes = {
  fn: PropTypes.any.isRequired,
  modal: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
  }),
  onZipCode: PropTypes.func,
  onIsValid: PropTypes.func,
  onAddress: PropTypes.func,
};
